import { IconButton } from '@mui/material';
import Iconify from 'src/components/iconify';
import { PATH_PAGE } from 'src/routes/paths';
import { Link as RouterLink } from 'react-router';

// ----------------------------------------------------------------------

export default function FaqItem() {
  return (
    <IconButton
      to={PATH_PAGE.faqs}
      component={RouterLink}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        '&:hover': {
          transform: 'scale(1.03)',
          bgcolor: 'action.hover',
        },
        width: 40,
        height: 40,
        borderRadius: 1.25,
        transition: (theme) => theme.transitions.create(['transform', 'background-color']),
      }}
    >
      <Iconify width={22} icon="material-symbols:help-outline-rounded" />
    </IconButton>
  );
}
